<ng-template ngxPermissionsOnly="doctor">
  <div
    id="sidebar"
        [ngClass]="{
            patient: (roles$ | async).hasOwnProperty(PATIENT),
            doctor: (roles$ | async).hasOwnProperty(DOCTOR),
            collapsed: (remoteVideoVisibility$ | async),
            'hide-side-bar': (hideSideBar$ | async)
        }"
    >
    @if (isNotRestricted(DASHBOARD)) {
      <div
        class="sidebar-child menu-element"
        (click)="changeTab(DASHBOARD)"
        (keydown.enter)="changeTab(DASHBOARD)"
            [ngClass]="{
                active:
                    isActiveTab(DASHBOARD) && !(remoteVideoVisibility$ | async)
            }"
        tabindex="1"
        >
        <span>
          <i class="fa fa-home is-active"></i>
          <i class="fal fa-home is-not-active"></i>
          <span class="description">{{
            "SIDEBAR.HOME" | translate
          }}</span>
        </span>
      </div>
    }
    @if (isNotRestricted(WAITINGROOM) && !isMUCEnabled) {
      <div
        class="sidebar-child menu-element"
        (click)="changeTab(WAITINGROOM)"
        (keydown.enter)="changeTab(WAITINGROOM)"
            [ngClass]="{
                active:
                    isActiveTab(WAITINGROOM) &&
                    !(remoteVideoVisibility$ | async)
            }"
        tabindex="2"
        >
        <span>
          <i class="fal fa-alarm-clock is-not-active"></i>
          <i class="fa fa-alarm-clock is-active"></i>
          <span class="description">{{
            "SIDEBAR.WAITINGROOM" | translate
          }}</span>
        </span>
      </div>
    }
    @if (isNotRestricted(TAN_CREATE)) {
      <div
        class="sidebar-child menu-element"
        (click)="changeTab(TAN_CREATE)"
        (keydown.enter)="changeTab(TAN_CREATE)"
            [ngClass]="{
                active:
                    isActiveTab(TAN_CREATE) && !(remoteVideoVisibility$ | async)
            }"
        tabindex="3"
        >
        <span>
          <i class="fal fa-calendar-edit is-not-active"></i>
          <i class="fa fa-calendar-edit is-active"></i>
          <span class="description">{{
            "SIDEBAR.TAN-CREATE" | translate
          }}</span>
        </span>
      </div>
    }
    @if (isNotRestricted(APPOINTMENT_OVERVIEW) && !isMUCEnabled) {
      <div
        class="sidebar-child menu-element appointment-overview"
        (click)="changeTab(APPOINTMENT_OVERVIEW)"
        (keydown.enter)="changeTab(APPOINTMENT_OVERVIEW)"
            [ngClass]="{
                active:
                    isActiveTab(APPOINTMENT_OVERVIEW) &&
                    !(remoteVideoVisibility$ | async)
            }"
        tabindex="4"
        >
        <span>
          <i class="fal fa-calendar-alt is-not-active"></i>
          <i class="fa fa-calendar-alt is-active"></i>
          <span class="description">{{
            "SIDEBAR.OVERVIEW" | translate
          }}</span>
        </span>
        @if (!hideTabBasedOnInstitution) {
          <span
            class="badge"
            [ngClass]="{ green: countAppointmentRequests > 0 }"
            >{{ countAppointmentRequests }}</span
            >
          }
        </div>
      }
      @if (
        isNotRestricted(APPOINTMENT_OVERVIEW_MULTIUSER) && isMUCEnabled
        ) {
        <div
          class="sidebar-child menu-element appointment-overview"
          (click)="changeTab(APPOINTMENT_OVERVIEW_MULTIUSER)"
          (keydown.enter)="changeTab(APPOINTMENT_OVERVIEW_MULTIUSER)"
            [ngClass]="{
                active:
                    isActiveTab(APPOINTMENT_OVERVIEW_MULTIUSER) &&
                    !(remoteVideoVisibility$ | async)
            }"
          tabindex="5"
          >
          <span>
            <i class="fal fa-calendar-alt is-not-active"></i>
            <i class="fa fa-calendar-alt is-active"></i>
            <span class="description">{{
              "SIDEBAR.OVERVIEW" | translate
            }}</span>
          </span>
        </div>
      }
      @if (
        isNotRestricted(APPOINTMENT_MULTIUSER_REQUESTS) &&
        isMUCEnabled &&
        !hideTabBasedOnInstitution
        ) {
        <div
          class="sidebar-child menu-element appointment-overview"
          (click)="changeTab(APPOINTMENT_MULTIUSER_REQUESTS)"
          (keydown.enter)="changeTab(APPOINTMENT_MULTIUSER_REQUESTS)"
            [ngClass]="{
                active:
                    isActiveTab(APPOINTMENT_MULTIUSER_REQUESTS) &&
                    !(remoteVideoVisibility$ | async)
            }"
          tabindex="6"
          >
          <span>
            <i class="fal fa-download is-not-active"></i>
            <i class="fa fa-download is-active"></i>
            <span class="description">{{
              "WAITINGROOM.TAB-REQUESTS" | translate
            }}</span>
          </span>
          @if (!hideTabBasedOnInstitution) {
            <span
              class="badge"
              [ngClass]="{ green: countAppointmentRequests > 0 }"
              >{{ countAppointmentRequests }}</span
              >
            }
          </div>
        }
        @if (isNotRestricted(PAYMENT)) {
          <div
            class="sidebar-child menu-element payment"
            (click)="changeTab(PAYMENT)"
            (keydown.enter)="changeTab(PAYMENT)"
            [ngClass]="{
                active:
                    isActiveTab(PAYMENT) && !(remoteVideoVisibility$ | async)
            }"
            tabindex="7"
            >
            <span>
              <i class="fal fa-wallet is-not-active"></i>
              <i class="fa fa-wallet is-active"></i>
              <span class="description"
                >{{ "SIDEBAR.PAYMENT" | translate }}
              </span>
            </span>
          </div>
        }
        @if (isNotRestricted(SETTING)) {
          <div
            class="sidebar-child menu-element"
            (click)="changeTab(SETTING)"
            (keydown.enter)="changeTab(SETTING)"
            [ngClass]="{ active: isActiveTab(SETTING) }"
            tabindex="8"
            >
            <span>
              <i class="fal fa-cog is-not-active"></i>
              <i class="fa fa-cog is-active"></i>
              <span class="description">{{
                "SIDEBAR.SETTING" | translate
              }}</span>
            </span>
          </div>
        }
        @if (isNotRestricted(HELP)) {
          <div
            class="sidebar-child menu-element"
            [ngClass]="{
                active: isActiveTab(HELP) && !(remoteVideoVisibility$ | async)
            }"
            (click)="changeTab(HELP)"
            (keydown.enter)="changeTab(HELP)"
            tabindex="9"
            >
            <span>
              <i class="fal fa-life-saver is-not-active"></i>
              <i class="fa fa-life-saver is-active"></i>
              <span class="description">{{
                "SIDEBAR.HELP" | translate
              }}</span>
            </span>
          </div>
        }
        <div class="sidebar-child version-element weight-300">
          <span>
            {{ "DASHBOARD.UPDATES.LATEST_UPDATE" | translate }}:
            {{ versionUpdatedDate }} Version: {{ version }}
          </span>
        </div>
      </div>
    </ng-template>
